"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_STYLE = void 0;
var BUTTON_STYLE = exports.BUTTON_STYLE = Object.freeze({
  width: '98%',
  minWidth: '150px',
  marginTop: '16px'
});